import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers";
import thunk from "redux-thunk";

function saveToLocalStorage(state) {
  try {
    const serialisedState = JSON.stringify(state);
    const reduxChangedEvent = new CustomEvent("redux");
    reduxChangedEvent.data = serialisedState;
    window.dispatchEvent(reduxChangedEvent);
    localStorage.setItem("persistantState", serialisedState);
  } catch (e) {
    console.warn(e);
  }
}

// load string from localStarage and convert into an Object
// invalid output must be undefined
function loadFromLocalStorage() {
  try {
    const serialisedState = localStorage.getItem("persistantState");
    if (serialisedState === null) return undefined;
    return JSON.parse(serialisedState);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}

export const store = createStore(
  reducers,
  loadFromLocalStorage(),
  applyMiddleware(thunk)
);

store.subscribe(() => saveToLocalStorage(store.getState()));

//https://medium.com/@jrcreencia/persisting-redux-state-to-local-storage-f81eb0b90e7e

//{user: {…}, isLoggedIn: true}
// isLoggedIn: true
// user:
// avatar: "https://ui-avatars.com/api/?size=250&bold=true&name=ddd+ddd"
// createdAt: "2021-08-17T22:04:58.566Z"
// email: "ozakkare@student.1337.ma"
// firstName: "ddd"
// isVerified: true
// lastName: "ddd"
// updatedAt: "2021-08-17T22:04:58.566Z"
// username: "user123"
// _id: "611c328a40720106a4ec34f3"
